import { BooleanFeatureFlag } from "@me8eon/featureflags";

export const managedNetworkFFName = "teamsManagedNetwork";
export const managedNetworkFeatureFlag: BooleanFeatureFlag = {
    value: false,
    description: "Assume the Teams call user is on a managed network and generate a sample network ID and BSSID",
};
